//
// Module providing ajax support to the framework
//
rs.module("common/ajax",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _ajaxHeaders;

        //
        // Initialization
        //
        function initialize(antiforgeryToken, requestCorrelationId, pageSecurityContextId, ajaxHeaders) {
            _ajaxHeaders = ajaxHeaders;

            var counter = 0;

            // We have to send along the antiforgery token in the header every time we do an AJAX post
            // so that ASP.NET can verify it
            $(document).ajaxSend(function (event, request, settings) {
                if (settings.type == "POST" || settings.type == "DELETE") {
                    request.setRequestHeader(ajaxHeaders.antiForgery, antiforgeryToken);
                }

                // If there is a correlation Id (there should always be), attach it to the request via a header.
                if (requestCorrelationId) {
                    request.setRequestHeader(ajaxHeaders.correlation, requestCorrelationId);
                }

                // Increment the ajax call counter for unique-ifying client identifiers during rendering.
                request.setRequestHeader(ajaxHeaders.counter, ++counter);

                // Include our page security context
                request.setRequestHeader(ajaxHeaders.securityContext, pageSecurityContextId);

                // Track the settings for use when performing the warning approval later.
                request.settings = settings;

                // Create a custom Deferred object to use so we can control when done/fail are called via .resolve()/.reject(), which 
                // are not exposed by jQuery on the xhr object.
                var customDeferred = $.Deferred();

                // Duplicate tracking of registered done()/fail() callbacks since we can't just pull them out of Deferred, they aren't exposed.  Futhermore,
                // Deferred objects cannot have their state reset which prevents us from first rejecting (when Warnings occur) and later
                // resolving resolving.
                var successCallbacks = [];
                var failCallbacks = [];

                // Attach our done callback to inspect the response for business messages.
                request.done(function (data, status, request) {

                    var resolveDeferred = true;

                    var messages = _getBusinessMessages(request);

                    // Put the messages collection on the request, making it available to all handlers.
                    request.rsMessages = messages;

                    if (messages && messages.ModelStateErrors && messages.ModelStateErrors.length > 0) {
                        request.modelStateErrors = messages.ModelStateErrors;
                    }

                    if (_anyBusinessMessages(messages)) {

                        // send messages to the event banner
                        _dispatchMessages(messages, request, successCallbacks, failCallbacks);

                        // handle the javascript promises based on what message types 
                        if (messages.Errors && messages.Errors.length > 0) {

                            // We do not want to resolve our Deferred, that would signal success and fire done() handlers.
                            resolveDeferred = false;

                            // Instead, reject our Deferred, which will fire all fail() callbacks on the current request.
                            customDeferred.reject(request, "One or more business exceptions occurred.", messages.Errors);
                        }
                        else if (messages.WarningGroups && messages.WarningGroups.length > 0) {
                            // Instead, reject our Deferred, which will fire all fail() callbacks on the current request.
                            resolveDeferred = false;

                            // We want to instead reject our Deferred, which will fire all fail() callbacks on the current request.
                            customDeferred.reject(request, "One or more business warnings occurred.", messages.WarningGroups);
                        }
                    }
                    else {
                        // There were no business messages in the response, so clear the event banner if settings indicate to do so
                        if (request.settings.clearEventBanner) {
                            eventBanner.removeAllMessages();
                        }
                    }

                    // Resolve our Deferred, which will fire all done() handlers.
                    if (resolveDeferred) {
                        customDeferred.resolve(data, status, request);
                    }
                });

                // Overwrite the done() function so we can collect all subsequent callback registrations and take control of when 
                // these callbacks are, or aren't, called based on the existence of business errors and warnings.
                request.done = function (callback) {

                    // Queue up the registered callback to our custom Deferred.
                    customDeferred.done(callback);

                    // Ideally we'd be able to access the registered callbacks on the Deferred objects, but they 
                    // don't get exposed.  So we just need to track them separately for use later.
                    successCallbacks.push(callback);

                    return request;
                };

                // Register our own callback for the request failure case
                request.fail(function (xhr, status, error) {

                    if (xhr.status === 401) {

                        var redirectLocation = xhr.getResponseHeader("location");
                        if (redirectLocation) {

                            // redirect where we're told
                            window.location = redirectLocation;

                            // abort, no handlers to call or anything
                            return;
                        }
                    }
                    else if (xhr.status === 403) {
                        // if the security context had expired, it is technically Forbidden but we want to show a more informative error message
                        if (xhr.getResponseHeader(_ajaxHeaders.securityContext + '-Invalid')) {
                            eventBanner.addErrorMessages(["This page has become dormant and must be reloaded before performing the requested action."]);
                        }
                        else {
                            // regular forbidden, the user know they don't have access
                            eventBanner.addErrorMessages(["You are not authorized to perform this action."]);
                        }
                    }

                    var messages = _getBusinessMessages(xhr);

                    if (messages) {
                        if (messages.ModelStateErrors && messages.ModelStateErrors.length > 0) {
                            request.modelStateErrors = messages.ModelStateErrors;
                        }
                        _dispatchMessages(messages, xhr, successCallbacks, failCallbacks);
                    }

                    // reject our Deferred, which will fire all registered fail() callbacks.
                    customDeferred.reject(xhr, status, error);
                });

                // Overwrite the fail() function so we can collect all subsequent callbck registraitons and take control of when
                // these callbacks are, or aren't called, based on the existence of business errors and warnings.
                request.fail = function (callback) {

                    // Queue up the registered callback to our custom Deferred.
                    customDeferred.fail(callback);

                    // Ideally we'd be able to access the registered callbacks on the Deferred objects, but they 
                    // don't get exposed.  So we just need to track them separately for use later.
                    failCallbacks.push(callback);

                    return request;
                };

                // Overwrite the always() function so we can get callbacks added to our custom Deferred, so they'll fire as we complete
                request.always = function (callback) {

                    // Queue up the registered callback to our custom Deferred.
                    customDeferred.always(callback);

                    return request;
                }

                // Setup a method to allow a page developer to have modelstate errors displayed on their fields
                request.showFieldErrors = function (validationMappings) {

                    // Add an always callback which will try to map modelstate errors with UI elements
                    customDeferred.always(function () {

                        if (request.modelStateErrors && request.modelStateErrors.length > 0) {
                            // go through each modelstate error entry, which is a key and its messages
                            for (let i = 0; i < request.modelStateErrors.length; i++) {
                                var entry = request.modelStateErrors[i];
                                if (validationMappings) {
                                    // The returned modelstate keys match the casing of the c# properties, while the attribute values in html
                                    // are going to be mixed or lowercase
                                    var propertyToFind = entry.Key.toLowerCase();
                                    for (var prop in validationMappings) {
                                        if (validationMappings.hasOwnProperty(prop) && propertyToFind == prop.toLowerCase()) {
                                            var element = validationMappings[prop];
                                            showErrors(element, entry.Errors);
                                        }
                                    }
                                }
                                else {
                                    // attempt to find the input whose name is, or whose last segment ends with, the modelstate key
                                    var propertyToFind = entry.Key.toLowerCase();

                                    // Look for elements with a name matching the key OR whose last segment of a dotted name matches the key
                                    $(`*[name$='.${propertyToFind}' i], *[name$='${propertyToFind}' i]`).each(function (index, element) {
                                        showErrors(element, entry.Errors);
                                    });
                                }
                            }
                        }

                        // Display jquery validation errors for the element
                        function showErrors(element, errors) {
                            var validator = $(element).closest("form").validate();
                            var name = $(element).attr('name');
                            validator.showErrors({
                                [name]: errors[0]
                            });
                        }
                    });

                    return request;
                }

                // if the deprecated ajax() syntax using a success parameter was used on the call, add it as a done() handler.  These
                // were captured in ajaxSettings.beforeSend()
                if (settings.legacySuccessCallback) {
                    request.done(settings.legacySuccessCallback);
                }

                // if the deprecated ajax() syntax using an error parameter was used on the call, add it as a fail() handler.  These
                // were captured in ajaxSettings.beforeSend()
                if (settings.legacyErrorCallback) {
                    request.fail(settings.legacyErrorCallback);
                }
            });

            // Setup ajax defaults
            $.ajaxSetup({

                // Custom beforeSend handling removes any deprecated success/error handlers passed as part of the ajax call.  We
                // are doing this because $.ajax() ends up adding these to the done()/fail() promises before we can interject ourselves 
                // and therefore this settings.success would end up getting called regardless of the presence of business messages since it 
                // would be fired before our custom handler (Deferred objects fire handlers in the order in which they are added.)
                // 
                // These removed handlers get added as part of ajaxSend, after the custom done()/fail() handlers.
                beforeSend: function (request, settings) {
                    settings.legacySuccessCallback = settings.success;
                    settings.legacyErrorCallback = settings.error;

                    settings.success = null;
                    settings.error = null;
                }
            });
        }

        //
        // Looks for the business messages header in the response and deserializes it.
        // 
        function _getBusinessMessages(request) {
            var encodedHeader = request.getResponseHeader(_ajaxHeaders.messages);

            if (encodedHeader) {
                var headerValue = atob(encodedHeader);
                if (headerValue) {
                    var messages = JSON.parse(headerValue);

                    if (_anyBusinessMessages(messages) ||
                        (messages.ModelStateErrors && messages.ModelStateErrors.length > 0)) {
                        return messages;
                    }
                }
            }

            // no messages in the response
            return null;
        }

        ///
        /// Look for the existence of Business Messages in the messages container
        /// 
        function _anyBusinessMessages(messages) {
            return messages && ((messages.Errors && messages.Errors.length > 0) ||
                (messages.WarningGroups && messages.WarningGroups.length > 0) ||
                (messages.InformationalMessages && messages.InformationalMessages.length > 0));
        }

        //
        // Populates the event banner with details from the messages object
        //
        function _dispatchMessages(messages, request, successCallbacks, failCallbacks) {
            if (messages.Errors && messages.Errors.length > 0) {

                // if the response is a redirect, or the code used when we ajax redirect (202), or if its specifically requested by settings, add delayed error messages
                if (request.status == 302 || request.status == 202 || request.settings.delayErrorMessages) {
                    eventBanner.addDelayedErrorMessages(...messages.Errors);
                }
                else {
                    eventBanner.addErrorMessages(...messages.Errors);
                }  
            }
            else if (messages.WarningGroups && messages.WarningGroups.length > 0) {
                eventBanner.addWarnings(messages.WarningGroups, request, successCallbacks, failCallbacks);
            }
            else if (messages.InformationalMessages && messages.InformationalMessages.length > 0) {

                // if the response is a redirect, or the code used when we ajax redirect (202), or if its specifically requested by settings, add delayed informational messages
                if (request.status == 302 || request.status == 202 || request.settings.delayInformationalMessages) {
                    eventBanner.addDelayedInformationalMessages(...messages.InformationalMessages);
                }
                else {
                    eventBanner.addInformationalMessages(...messages.InformationalMessages);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);

